<template>
  <div @click="openLayer">
    <slot/>
  </div>
</template>

<script>/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2022杭州吉簿云数字科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2022年10月16日</li>
 * <li>@author     : ____′↘林永雄</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import {layer} from "@layui/layer-vue";
import {routeList} from "@/router";
import {h} from "vue";

export default {
  name: "RouterLink",
  emits: ['success'],
  props: {
    to: Object,
    tag: String,
    icon: String,
    width: {
      type: String,
      default: "50vw"
    },
  },
  data() {
    return {
      title: ""
    }
  },
  methods: {
    openLayer() {
      if (!this.to || !this.to.name) return;
      let find = routeList.find(value => value.name === this.to.name);
      if (!find) return;
      this.title = find.title;
      let layerId = null;
      const compProps = Object.assign({}, this.to.params || {}, {
        onSuccess: (args) => { this.$emit('success', args) },
        onClose: (args) => { layer.close(layerId); }
      });
      layerId = layer.drawer({
        title: this.title,
        shadeClose: false,
        zIndex: 1002,
        area: [this.width, '100vh'],
        content: h(find.component, compProps),
        onClose: (args) => { this.$emit('success', args) }
      });
    }
  },
}
</script>
